import React from "react";

import { Dashboard } from "./components/dashboard.js";

const DashboardPage = () => <Dashboard />;

export default DashboardPage;
